import List from "./List";
import BullsEyeArrow from "mdi-material-ui/BullseyeArrow";

export const SummaryList = List;
export const SummaryIcon = BullsEyeArrow;
